import React from 'react';

import Relay from 'react-relay';

import Helmet from 'react-helmet';

import { formatProductPrice } from 'depop/utils/money';
import selectImage from 'depop/utils/selectImage';
import { limitStringChars } from 'depop/utils/textUtils';

import { injectIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'ProductDetail.title',
    defaultMessage: 'Listed on Depop by {username}',
    description: 'Product detail title',
  },
});

class ProductDetailHead extends React.Component {
  props: {
    product: Object,
    intl: {
      formatMessage: (
        key: string,
        params: { [name: string]: string },
      ) => string,
    },
  };

  render() {
    const { product, intl } = this.props;

    const format = selectImage(product.pictures[0].formats, 1024);
    const title = intl.formatMessage(messages.title, {
      username: product.seller.username,
    });
    const canonicalUrl = `https://www.depop.com/${product.seller.username}/${product.slug}/`;

    return (
      <Helmet
        title={ product.description ? limitStringChars(product.description, 60) : '' }
        link={[
          {
            rel: 'canonical', href: canonicalUrl
          }
        ]}
        meta={[
          { name: 'description', content: product.description ? limitStringChars(product.description, 160) : '' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:title', content: title },
          { name: 'twitter:description', content: product.description },
          {
            name: 'twitter:app:url:iphone',
            content: `depop://product/${product.publicId}`,
          },
          {
            name: 'twitter:app:url:ipad',
            content: `depop://product/${product.publicId}`,
          },
          { name: 'twitter:image', content: format.url },
          {
            name: 'twitter:data1',
            content: formatProductPrice(
              product.price.display,
              product.price.currencySymbol,
            ),
          },
          { name: 'twitter:label1', content: 'Price' },
          { name: 'twitter:data2', content: product.approximateAddress },
          { name: 'twitter:label2', content: 'Location' },
          { property: 'og:title', content: title },
          { property: 'og:type', content: 'product' },
          { property: 'og:image', content: format.url },
          { property: 'og:image:width', content: format.width },
          { property: 'og:image:height', content: format.height },
          { property: 'og:description', content: product.description },
          { property: 'og:price:amount', content: product.price.display },
          { property: 'og:price:currency', content: product.price.currency },
        ]}
      />
    );
  }
}

export default Relay.createContainer(injectIntl(ProductDetailHead), {
  fragments: {
    product: () => Relay.QL`
      fragment on Product {
        publicId
        approximateAddress
        slug
        description
        pictures {
          url
          width
          height
          formats {
            width
            height
            url
          }
        }
        seller {
          username
        }
        price {
          display
          currency
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/shops/views/_ProductDetailHead.js